export default __webpack_public_path__ + "static/media/game.572be160.png";